import localforage from 'localforage'
import { v4 as uuidv4 } from 'uuid'
import { trim } from '@/helpers'

export const initialize = async ({ commit, dispatch }, userId) => {
    const chat = await axios.get('/chat/initialize').then((v) => v.data)

    chat.users = chat.users.map((user) => {
        user.id = parseInt(user.id)
        user.coach_id = user.coach_id ? parseInt(user.coach_id) : null
        user.patient_id = user.patient_id ? parseInt(user.patient_id) : null

        return user
    })

    if (_.isString(userId)) {
        userId = parseInt(userId)
    }

    const user = _.find(chat.users, userId ? { id: userId } : { active: true })

    commit('setChat', chat)
    commit('setConversation', user)
}

export const fetchAvailableChannels = async ({ commit, dispatch, state }, patientId) => {
    const url = `/api/chat/${patientId}/available-channels`

    const channels = await axios.get(url).thenData()

    commit('setChannels', channels)
    commit('setMessages', [])
}

export const fetchMessages = async ({ commit, dispatch, state }, fetchOnlyLast = false) => {
    if(fetchOnlyLast) {
        const url = `/api/chat/fetch-messages/${state.conversation.id}`

        const messages = await axios.get(url).thenData()

        commit('addLastMessage', messages.pop())
    } else {
        commit('setMessages', [])

        state.channels.forEach(channel => {
            dispatch('fetchMessagesChannel', channel.channel_id)
        })
    }
}

export const fetchMessagesChannel = async ({ commit, dispatch, state }, channelId) => {
    const url = `/api/chat/fetch-messages-channel/${channelId}`

    const messages = await axios.get(url).thenData().catch(e => {
        console.log(e.response)
    })

    commit('setMessagesChannel', messages)
}

export const sendMessage = async ({ dispatch, commit, state, rootState }, { body, files, channel_id }) => {
    let url = '/api/chat/send-message'
    const conversation = state.conversation
    const uuid = uuidv4()

    channel_id = channel_id || conversation.channel_id

    if (rootState.general.user.role === 'coach') {
        url += '/' + channel_id
    }

    await axios.post(url, {
        body: body,
        uuid,
        channel_id
    }).then(() => {
        if (files.length !== 0) {
            dispatch('submitFiles', { files, uuid, channel_id })
        } else {
            dispatch('fetchMessages', true)
        }
    }).catch(e => {
        // add the message to local list
        if (!channel_id || (conversation && channel_id === conversation.channel_id)) {
            commit('addMessage', { uuid, body, from: rootState.general.user.id, files, success: false })
        }
    })
}

export const changeConversation = async ({ commit, dispatch, state }, id) => {
    if (!state.chat) {
        return
    }
    const conversation = _.find(state.chat.users, { id })

    commit('setConversation', conversation)
    dispatch('fetchMessages')
}

export const loadChatWidget = async ({ commit, dispatch }) => {
    const chatWidget = await localforage.getItem('chat-widget-v2')

    if (chatWidget && chatWidget.open) {
        $('#modal-chat-message').modal('show')
        $('body').removeClass('modal-open')
    }

    commit('updateChatWidget', chatWidget)
}

export const openChatWidget = ({ state, commit }, message) => {
    commit('updateChatWidget', {
        open: true,
        conversation: state.conversation,
        message
    })
}

export const submitFiles = async ({ commit, dispatch }, { files, uuid, channel_id }) => {
    if (files.length === 0) {
        return
    }

    const formData = new FormData()

    formData.append('channel_id', channel_id);

    for (let i = 0; i < files.length; i++) {
        const file = files[i]

        formData.append(`files[${i}]`, file)
    }

    axios.post(`/api/chat/message/${uuid}/files`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    }).then((e) => {
        dispatch('fetchMessages')
    }).catch(e => {
        console.error(e.response)
    })
}

export const deleteMessage = async ({ state, commit }, {message, channel_id}) => {
    const uuid = message.uuid

    await axios.delete('/api/chat/message', {
        data: { channel_id: channel_id, uuid: uuid }
    }).then(() => {
        commit('removeMessage', message)
    }).catch(e => {
        console.log(e.response)
    })
}

export const unreadMessage = async ({ commit, dispatch }, { channel_id, msg_count }) => {
    const formData = new FormData()

    formData.append('messages_count', msg_count);

    axios.post(`/api/chat/${channel_id}/mark-unread`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    }).then((e) => {
        console.log("unread")
    }).catch(e => {
        console.error(e.response)
    })
}

export const updateMessage = async ({ dispatch, commit, state, rootState }, { body, uuid, channel_id, files }) => {
    let url = '/api/chat/message'
    const conversation = state.conversation

    channel_id = channel_id || conversation.channel_id

    await axios.put(url, {
        text: body,
        uuid: uuid,
        channel_id: channel_id
    }).then(() => {
        if (files.length !== 0) {
            dispatch('submitFiles', { files, uuid, channel_id })
        } else {
            dispatch('fetchMessages')
        }
    }).catch(e => {
        console.log(e.response)
        // add the message to local list
        if (!channel_id || (conversation && channel_id === conversation.channel_id)) {
            commit('addMessage', { uuid, body, from: rootState.general.user.id, files, success: false })
        }
    })
}
